'use client';

import * as React from 'react';

import { ResourceBadge } from '@/components/ui/resource-badge';
import { useOrgNavigate } from '@/hooks/use-app-navigate';

interface StoreResourceBadgeProps {
  storeId: string;
  storeName: string;
  storeType?: string;
  appLink?: string;
  variant?: 'default' | 'secondary' | 'destructive' | 'outline';
  className?: string;
}

/**
 * StoreResourceBadge component for displaying store information
 * Inherits from generic ResourceBadge
 */
export function StoreResourceBadge({
  storeId,
  storeName,
  storeType,
  variant = 'secondary',
  className,
}: StoreResourceBadgeProps) {
  const { orgRoutes } = useOrgNavigate();
  // Display store name with optional type
  const displayValue = React.useMemo(() => {
    return storeType ? `${storeName} (${storeType})` : storeName;
  }, [storeName, storeType]);

  return (
    <ResourceBadge
      name="store"
      value={displayValue}
      appLink={orgRoutes.STORE(storeId)}
      variant={variant}
      className={className}
    />
  );
}
